import { Select } from "antd";
import React, { useEffect } from "react";
import Error from "../Error";
import { select_search } from "../../Controllers/Global";

const Selectcomponent = React.forwardRef((props, focus) => {
  const { index, ind, val, form, setForm, getFormdata, selectHandlers } = props;

  useEffect(() => {
    if (!form || !Array.isArray(form)) return;

    let categoryValue = null;

    form.forEach((section) => {
      section.options.forEach((opt) => {
        if (opt?.form?.name === "category" && opt?.form?.value) {
          categoryValue = opt.form.value;
        }
      });
    });

    if (!categoryValue) return;

    const updatedForm = form.map((section) => {
      const updatedOptions = section.options.map((opt) => {
        if (opt?.form?.name === "associatedaccounts") {
          return {
            ...opt,
            form: {
              ...opt.form,
              category: categoryValue,
            },
          };
        }
        return opt;
      });
      return { ...section, options: updatedOptions };
    });

    if (
      form.some((section) =>
        section.options.some(
          (opt) =>
            opt?.form?.name === "associatedaccounts" &&
            opt?.form?.category !== categoryValue
        )
      )
    ) {
      setForm(updatedForm);
      getFormdata(updatedForm);
    }
  }, [form]);

  const handleSelect = (e, index, ind) => {

    let data = [...form];
    if (data[index].options[ind].form.name === "category") {
      data.forEach((section) => {
        section.options.forEach((opt) => {
          if (opt?.form?.name === "associatedaccounts") {
            opt.form.category = e;
          }
        });
      });
    }

    data[index].options[ind].form.value = e;

    if (data[index]?.options[ind]?.show?.check) {
      data?.map((value, k) => {
        value?.options?.map((val, i) => {
          if (val?.show?.name == data[index].options[ind].form.name) {
            data[k].options[i].show.status = e ? true : false;
          }
        });
      });
    }

    setForm(data);
    getFormdata(data);

    if (selectHandlers && selectHandlers[val?.form?.name]) {
      selectHandlers[val?.form?.name](e, data);
    }

  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };

  const handleSearch = async (e, index, ind) => {
    let data = [...form];

    const normalize = (str) => {
      return str
        ?.toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]/g, "");
    };

    let select;
    if (data[index].options[ind].form.source) {
      if (data[index].options[ind].form.source === "Sales-Return") {
        select = {
          api: data[index].options[ind].form.api,
          search: normalize(e),
          status: 1,
          source: data[index].options[ind].form.source,
          customer: data[index].options[0].form.value,
        };
      } else {
        select = {
          api: data[index].options[ind].form.api,
          search: normalize(e),
          status: 1,
          source: data[index].options[ind].form.source,
          category: data[index].options[ind].form.category,
        };
      }
    } else {
      select = {
        api: data[index].options[ind].form.api,
        search: e,
        status: 1,
      };
    }

    const search = await select_search(select);

    if (search?.status || search?.success) {
      if (data[index].options[ind].form.name == "salesman") {
        let options = [];
        search?.data?.data.map((value, index) => {
          options?.push({ value: value?._id, label: value?.name ? value?.name : value?.number ? value?.number : "" });
        });

        data[index].options[ind].form.options = options;
        setForm(data);
        getFormdata(data);

        if (selectHandlers && selectHandlers[val?.form?.name]) {
          selectHandlers[val?.form?.name](e, data);
        }
      } else {
        let options = [];
        const items = search?.data?.data || search?.data || [];
        items?.map((value) => {
          if (data[index].options[ind].form.source === "Sales-Return") {
            const formattedDate = formatDate(value?.created);
            options.push({
              value: value?._id,
              label: `${value?.number} - ${formattedDate}`
            });

          } else {
            options.push({
              value: value?._id,
              label: value?.name ? value?.name : value?.number ? value?.number : ""
            });
          }
        });


        data[index].options[ind].form.options = options;
        setForm(data);
        getFormdata(data);
      }
    } else {
      getFormdata(data);
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <Select
        key={index}
        id={index?.toString()?.concat(ind)}
        name={val?.form?.name}
        placeholder={val?.form?.placeholder}
        className={
          val?.form?.className ? val?.form?.className : "text-regular w-full"
        }
        disabled={val?.form?.disabled ? val?.form?.disabled : false}
        suffixIcon={val?.form?.suffixIcon}
        ref={focus.current[val?.form?.name?.concat(index + "" + ind)]}
        size={val?.form?.size}
        mode={val?.form?.mode}
        allowClear={val?.form?.allowClear}
        showSearch={val?.form?.showSearch}
        filterOption={val?.form?.filterOption}
        options={val?.form?.options}
        value={val?.form?.value}
        onKeyDown={handleOnKeyDown}
        onClick={() => handleSearch("", index, ind)}
        onFocus={() => handleSearch("", index, ind)}
        onSearch={(e) => handleSearch(e, index, ind)}
        onChange={(e) => handleSelect(e, index, ind)}
        autoComplete="off"
      />
      <Error id={val?.form?.name?.concat(index + "" + ind)} />
    </React.Fragment>
  );
});

export default Selectcomponent;
